import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import {
  FormHelperText,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material";
import customIcon from '../../assets/images/Vector.svg';
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import { getCities } from "../../actions/userActions/cityAction";
import { getPracticeLocations } from "../../actions/userActions/practiceLocationAction";
import { addVisitProfile, getvisitProfile, getVisitProfileDetail, updateVisitProfile } from "../../actions/userActions/VisitProfileAction";
import VisitlocationsRow from "./VisitlocationsRow";
import "./AddVisitprofile.css";
import AddButton from "../subComponents/buttons/CustomAddButton";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import Heading6Regular from "../designSystem/Heading6Regular";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import BodySmallRegular from "../designSystem/BodySmallRegular";
import TextField from "../designSystem/TextField";
import SingleSelect from "../designSystem/SingleSelect";
import { Check } from "lucide-react";
import { validateFields } from "../../utils/Validations";
import { getEmployee } from "../../actions/userActions/employeeAction";

const AddVisitProfile = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const allCities = useSelector((state) => state.cities_reducer.cities);
  const addProfileStatus = useSelector((state) => state.visitProfile_reducer.addVisitProfile);
  const updateProfileStatus = useSelector((state) => state.visitProfile_reducer.updateVisitProfile);
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const visitProfileData  = useSelector(state => state.visitProfile_reducer.visitProfileDetail);
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.result[0]?.user?.id;
  useEffect(() => {
    dispatch(getEmployee(userId));
  }, []);
  const [sysytemGeneratedName, setSysytemGeneratedName] = useState("");
  const employeeData = useSelector((state) => state.employees_reducer.employee);
  console.log(employeeData, 'dat');

  const initialValues = {
    visitProfileId: 0,
    name: "",
    city: "",
    rows: [{ visitLocationId: 0, practiceLocation: "", doctors: [] }],
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({}); 
  useEffect(() => {
    if (location.visitProfile) {
      const profileRow = location.visitProfile.row;
 setFormValues({
        ...formValues,
        visitProfileId: profileRow.visitProfileId,
        name: profileRow.profileName,
        city: profileRow.cityId,
        rows: profileRow.visitLocations.map((loc) => ({
          visitLocationId: loc.visitLocationId,
          practiceLocation: loc.practiceLocationId,
          doctors: loc.doctorIds,
        })),
      });
       setSysytemGeneratedName(profileRow.systemGeneratedName);
    } else {
       setSysytemGeneratedName(employeeData?.systemGeneratedProfileName || "");
    }
  }, [location.visitProfile, employeeData]);

  useEffect(() => {
    dispatch(getCities({ filter: { countryId: "1" }, pageNumber: -1, pageSize: 0 }));
  }, [dispatch]);

  useEffect(() => {
    if (formValues.city) {
      dispatch(getVisitProfileDetail({ cityId: formValues.city }));
    }
  }, [dispatch, formValues.city]);
  const getOptions = () => {
    return (
      allCities !== "isLoading" &&
      allCities.length !== 0 &&
      allCities.result?.[0]?.cities?.length !== 0 &&
      allCities.result[0].cities
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((city) => ({
          value: city.id,
          label: city.name
        }))
    ) || [];
  };
  const handleChange = (name, value) => {
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleAddRow = () => {
    setFormValues((prevState) => ({
      ...prevState,
      rows: [
        ...prevState.rows,
        { visitLocationId: 0, practiceLocation: "", doctors: [] },
      ],
    }));
  };


  const handleRemoveRow = (rowIndex) => {
    setFormValues((prevState) => ({
      ...prevState,
      rows: prevState.rows.filter((_, index) => index !== rowIndex),
    }));
  };
 const handleSubmit = () => {

    const errors = validateFields(formValues, 'visitProfile');
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const visitProfileData = {

        visitProfileId: formValues.visitProfileId,
        profileName: formValues.name,
        cityId: formValues.city,
        visitLocations: formValues.rows.map((row) => ({
          visitLocationId: row.visitLocationId,
          practiceLocationId: row.practiceLocation,
          doctorIds: row.doctors,
        })),
      };

      if (location.visitProfile) {
        dispatch(updateVisitProfile(visitProfileData));
      } else {
        dispatch(addVisitProfile(visitProfileData));
      }
      history.push("/admin/visitProfiles");
    }
  };
  const handleCityChange = (event) => {
    setFormValues({
      ...formValues,
      city: event.value
    })
  }
  const handleGoBack = () => {
    history.goBack();
  };

  return (<>
    {addProfileStatus && addProfileStatus != "isLoading" && <Redirect to="/admin/visitProfile" />}
    {updateProfileStatus && updateProfileStatus != "isLoading" && <Redirect to="/admin/visitProfile" />}
    {!location.visitProfile && <Redirect to="/admin/AddVisitProfile" />}
    {!permissions.includes("CanAddVisitProfile") && <Redirect to="/admin" />}
    {!permissions.includes("CanUpdateVisitProfile") && <Redirect to="/admin" />}
    <div className="add-visit-profile-container">
      <div className="content-header">
        <div className="header-navigation">
          <BodySmallMedium text="Manage" color="#A1A2A4" />
          <img
            src={chevron_rightIcon} alt="Chevron Right" className="chevron-right-icon" />
          <BodySmallMedium text="Visit Profile" color="#1E293B" />
        </div>

      </div>
      <Heading6Regular text="Visit Profile" color="#1E293B" />
      <div className="add-content-wrapper">
        <div className="row">
          <div className="col-4">
          <TextField
      name="sysytemGeneratedName"
      label="Name"
      type="text"
      disabled
      value={sysytemGeneratedName}
      placeholder=""
    />
          </div>
          <div className="col-4">
            <TextField
              name="name"
              label="Display Name"
              type='text'
              value={formValues.name}
              onChange={handletextChange}
              placeholder='Enter display name'
              error={formErrors.name}
            />
          </div>
          <div className="col-4">
            <SingleSelect
              label="City"
              isSearchable
              secondaryLabel
              iconEnd
              error={formErrors.city}
              disabled={!!location.visitProfile?.row.cityId}
              onChange={handleCityChange}
              value={formValues.city}
              placeholder='Select city'
              options={(allCities &&
                allCities !== "isLoading" &&
                allCities.length !== 0 && allCities.result?.[0]?.cities &&
                allCities.result?.[0]?.cities.length !== 0)
                && getOptions("allCities")}
            />
          </div>
        </div>

        <hr />

        <div className="add-visit-profile-row-container">
          {formValues.rows.map((row, index) => (
            <VisitlocationsRow
              key={index}
              row={row}
              index={index}
              formValues={formValues}
              visitProfileData={visitProfileData}
              formErrors={formErrors}
              setFormValues={setFormValues}
              setFormErrors={setFormErrors}
              handleRemoveRow={handleRemoveRow}
            />
          ))}
          <div className="add-visit-profile-form-actions-left">
            <AddButton
              onClick={handleAddRow}
              text="+ Add Another"
            />

          </div>
        </div>

        <hr />

        <div className="add-visit-profile-form-actions">
          <CancelButton onClick={handleGoBack} text="Cancel" />
          <PrimaryButton
            onClick={handleSubmit}
            isLoading={addProfileStatus === "isLoading" || updateProfileStatus === "isLoading"}
            text={location.visitProfile ? "Update" : "Save"}
            icon={Check}
            width="100px"
            height="50px"
          />

        </div>
      </div>
    </div>
  </>

  );
};

export default AddVisitProfile;
